<template>
  <lb-dialog
    v-model="internalValue"
    :heading="heading"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        <div class="d-flex flex-column gap-3" data-testid="previous-cycle-list-dialog__body">
          <div v-if="!loading && previouscyclelist.length === 0" class="pa-4 grey--text text-center font-size-md">
            {{ emptyMessage }}
          </div>
          <div v-else class="d-flex flex-column gap-3">
            <div>
              <v-chip class="noTransform ru-info-chip gap-2 align-center">
                <span><v-icon>mdi-information-outline</v-icon> Please select the period from which you want to copy the {{ commentaryLabel }} commentary.</span>
              </v-chip>
            </div>
            <lb-datatablenew
              :headers="headers"
              :items="tableItems"
              :loading="loading"
              :enableslot="['stage']"
              hide-default-footer
              hide-column-selector
              hide-pagination
            >
              <template #stage="{ item }">
                <status-indicator
                  :variant="getVariant(item.stage)"
                  :custom-label="getLabel(item.stage)"
                  size="sm"
                />
              </template>
            </lb-datatablenew>
          </div>
        </div>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
import StatusIndicator from '../components/StatusIndicator.vue';
import { STATUS_VARIANTS } from '../utils/statusConstants';

export default {
  name: 'PreviousCycleListDialog',
  components: { StatusIndicator },
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    heading: { type: String, default: 'Previous Commentary Period List' },
    width: { type: [String, Number], default: '50%' },
    commentaryLabel: { type: String, default: 'Local' },
    previouscyclelist: { type: Array, default: () => [] },
    emptyMessage: { type: String, default: 'No previous cycle found' },
  },

  data() {
    return {
      headers: [
        { text: 'S.No', value: 'sl_no', width: '80px', sortable: false },
        { text: 'Year', value: 'year' },
        { text: 'Month', value: 'month' },
        { text: 'Status', value: 'stage' },
      ],
      STATUS_VARIANTS,
    };
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    tableItems() {
      return this.previouscyclelist.map((entry, index) => ({
        ...entry,
        sl_no: index + 1,
        year: entry.period_detail?.year,
        month: new Date(0, entry.period_detail?.number - 1).toLocaleString('en-US', { month: 'long' }) || '',
        stage: entry.stage,
        __click: (item) => this.selectCycle(item._id),
      }));
    },
  },
  methods: {
    selectCycle(id) {
      this.$emit('select', id);
    },
    getVariant(stage) {
      if (stage === 0) return STATUS_VARIANTS.OPEN;
      if (stage === 1) return STATUS_VARIANTS.APPROVED;
      return STATUS_VARIANTS.UNKNOWN;
    },
    getLabel(stage) {
      if (stage === 1) return 'Closed';
      return undefined;
    },
  },
};
</script>
